import styled from "styled-components";

import HomeSVG from "assets/home.svg";
import KredobankLogo from "assets/kredobank-logo.svg";
import Eclipse from "components/Eclipse/Eclipse";
import Button from "components/Button/Button";
import InformationText from "components/InformationText/InformationText";
import SquareThree from "images/squarethree.jpg";

import FirstBanner from "../../static/FirstBanner.png";
import SecondBanner from "../../static/secondBaner.png";
export const Wrapper = styled.div`
  width: 100vw;
  // background: ${({ theme }) => theme.colors.home.homeBackground};
  display: flex;
  flex-direction: column;
`;

export const View = styled.div`
  // height: 100vh;
  width: 100%;

  display: flex;
  position: relative;
  padding: 0 35px;
  min-height: 600px;

  max-width: 1680px;
  margin-inline: auto;

  @media (max-width: 450px) {
    padding: 0 3px;
  }

  // @media (max-height: 350px) and (orientation: landscape) {
  //   min-height: 600px;
  // }

  // @media (max-width: 1100px), (min-height: 1100px) {
  //   max-height: 800px;
  // }
`;

export const FirstView = styled(View)`
  background: url('${FirstBanner}');
  background-repeat:no-repeat;
  background-size:cover;
  height: auto !important;
  max-width: 1680px;
  margin-inline:auto;
  align-items: end;


  @media (min-height: 1200px) and (min-width: 900px) {
    flex-direction: column;
    align-items: end;
    justify-content: center;
  }

  @media (max-width:425px){
    align-items: center;

  }
`;

export const EditedInformation = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  z-index: 55;
  margin-left: 30px;
  overflow: hidden;
  min-width: 50vw;
  margin-bottom: 10%;

  @media (max-width: 1100px) {
    margin-top: 20px;
    align-items: center;
  }

  @media (max-width: 730px) {
    margin-top: 50px;
  }

  @media (max-width: 450px) {
    margin-left: 0;
  }

  @media (min-height: 1200px) and (min-width: 900px) {
    min-width: 80vw;
    max-height: 50vh;
    align-items: center;
  }
`;

export const SecondView = styled(View)`
  background: white;
  margin-top: 120px;
  padding-left: 0px;
  color: rgb(0, 173, 17);
  flex-wrap: wrap;

  @media (max-width: 730px) {
    margin-top: 20px;
  }
`;
export const ThirdView = styled(View)`
  display: flex;
  align-items: self-end;
  min-height: 900px;
  margin-top: 120px;
  background-image: url(${SecondBanner});
  background-size: cover;
  margin-bottom: 0px;

  @media (max-width: 730px) {
    margin-top: 20px;
    align-items: center;
    min-height: 600px;
  }
`;

export const ThirdContent = styled.div`
  background-image: url("data:image/png;base64,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");
  background-repeat: no-repeat;
  padding-bottom: 130px;
  margin-left: 130px;
  margin-top: 356px;
  padding-left: 50px;
  padding-top: 40px;
  padding-right: 70px;
  width: 100%;
  max-width: 480px;

  @media (max-width: 730px) {
    margin-top: 0;
    margin-left: 60px;
  }
  @media (max-width: 520px) {
    max-width: 90vw;
    margin-inline: auto;
    padding-top: 10px;
  }
`;
export const TitleDec = styled.p`
  padding-top: 22px;
  font-size: 22px;
  width: 360px;
  color: white;
  max-width: 90vw;

  
  
  @media (max-width: 425px) {
    padding-top: 0;
    width: 100%;
  }
`;

export const AboutText = styled.p`
  color: black;
  font-size: 22px;
  max-width: 578px;
  line-height: 36px;
  text-align: left;
  font-family: Roboto;
  margin: 8px 0px;
`;

export const InfoText = styled(InformationText)`

  font-size: 22px;
  color: white;
        max-width: 500px;
        font-family: Roboto;
        margin: 8px 0px;




  // @media (min-width: 1750px) {
  //   font-size: ${({ theme }) => `calc(${theme.fontSize.xxxs} + 0.3vmax)`};
  //   max-width: 700px;
  // }
`;

export const AboutContainer = styled.div`
  display: flex;
  flex-direction: column;
  // -webkit-box-pack: center;
  // justify-content: center;
  max-width: 590px;
  // margin-top: 35px;
  margin-left: 50px;

  @media (max-width:1124px){
    margin-left: 10px;

    max-width:50%;
  }

  @media (max-width: 850px) {
    margin-left: 0;
    width:90vw;
    margin-inline:auto;
    max-width:100%
  }
`;

export const AboutImg = styled.div`
  width:40%;
  height:100%;

  @media (max-width:850px){
    width: 50%;
    margin-inline: auto;
  }


  @media (max-width: 700px) {
    display: none;
  }
`;

export const AboutIcon = styled.div`
  width: 100%;
  display: flex;
  margin-top: 20px;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (min-width: 731px) {
    -webkit-box-pack: justify;
    justify-content: space-between;
  }

  @media(max-width:426px){
     justify-content: center;
  }
`;
export const IconBlock = styled.div`
  text-align: center;
  width: 145px;
  margin-bottom: 12px;

  @media (min-width: 731px) {
    margin-right: 0px !important;
  }
`;
export const IconWrapper = styled.div`
  height: 100px;
`;

export const AboutTitle = styled.h2`
  font-size: 48px;
  color: rgb(0, 173, 17);

  @media (max-width:425px){
    font-size:30px;
  }
`;

export const SVGContainer = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;

  @media (min-height: 1200px) and (min-width: 900px) {
    min-width: 80vw;
    max-height: 50vh;
    align-items: center;
  }
`;

export const EditedHomeSVG = styled(HomeSVG)`
  height: 80%;
  position: relative;
  right: 10%;
  z-index: 50;

  @media (max-width: 1200px) {
    height: 70%;
  }
`;

export const EditedEclipse = styled(Eclipse)`
  position: absolute;
  top: -50%;
  right: -30%;
  z-index: 0;
`;

export const EditedButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.home.buttonBlue};
`;

export const InformationContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 100;

  &:before {
    content: "";
    position: absolute;
    width: 500px;
    height: 500px;
    background-color: ${({ theme }) => theme.colors.eclipseBlack};
    border: none;
    border-radius: 50%;
    z-index: 0;
    right: -10%;
    top: 0;
    @media (max-width: 730px) {
      display: none;
    }
  }

  @media (max-width: 800px) {
    margin: 0 40px;
  }
`;
export const SquaresContainer = styled(InformationContainer)`
  &:before {
    display: none;
  }
`;

export const InformationSquaresContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  @media (min-width: 2000px) {
    justify-content: space-evenly;
    transform: scale(1.1);
  }

  @media (max-height: 600px) {
    margin-bottom: 20px;
  }
`;

export const InformationSquareImage = styled.div`
  width: 400px;
  height: 230px;
  background-image: url(${SquareThree});
  background-size: cover;
  margin-left: 15px;
`;

export const LastView = styled(View)`
  width: 100%;
  height: auto;
  display: flex;
  align-items: start;
  justify-content: space-evenly;
  flex-wrap: wrap;
  min-height: 480px;
  margin-top: 120px;

  @media (max-height: 730px) {
    height: auto;
    margin-top: 30px;
    // min-height: 120vh;
  }
`;

export const TitleLine = styled(InformationText)`
  color: rgb(0, 173, 17);
  font-size: 42px;
  font-weight: bold;
  line-height: 40px;
`;

export const TextLine = styled(InformationText)`
  line-height: 36px;
  font-size: 22px;
  color: black;
  max-width: 500px;
  font-family: Roboto;
  margin: 8px 0px;
`;
export const LinkToContact = styled(InformationText)`
  font-size: 22px;
  color: rgb(0, 173, 17);
  text-decoration: underline;
`;
export const LastInfo = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  margin-left: 50px;

  @media (max-width: 730px) {
    width: 100%;
  }
`;

export const EditedKredobankLogo = styled(KredobankLogo)`
  height: 60px;
  width: auto;
  margin-right: 16px;
  justify-self: flex-start;
  margin-top: 8px;

  @media (max-width: 800px) {
    height: 40px;
  }

  @media (max-width: 600px) {
    margin-right: 0;
    margin: 24px 0;
    align-self: flex-start;
  }

  @media (max-width: 1200px) {
    height: 45px;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: auto;
  height: auto;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
